module.exports = __webpack_public_path__ + "static/media/covi_ppe_dis_glo.136c3a58.png";